import { render, staticRenderFns } from "./TaskMoneyConfigage.vue?vue&type=template&id=66ec017a&"
import script from "./TaskMoneyConfigage.vue?vue&type=script&lang=js&"
export * from "./TaskMoneyConfigage.vue?vue&type=script&lang=js&"
import style0 from "./TaskMoneyConfigage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports